import { isNative } from "./platform";
import { api } from "../api";

/**
 * Start the Gmail connect flow. The server's GET /api/gmail/connect returns the
 * Google consent URL (bearer-authenticated; tenant travels in a signed state
 * JWT). On web we just navigate there. On native we open it in a Custom Tab;
 * the server callback redirects to the /gmail-return App Link (see gmail.ts +
 * the manifest intent-filter), which reopens the app — we then close the tab.
 */
export async function connectGmail(): Promise<void> {
  const { url } = await api.get<{ url: string }>("/api/gmail/connect");

  if (!isNative()) {
    window.location.href = url;
    return;
  }

  const { Browser } = await import("@capacitor/browser");
  const { App } = await import("@capacitor/app");
  await Browser.open({ url });
  const sub = await App.addListener("appUrlOpen", async ({ url: opened }) => {
    if (opened.includes("/gmail-return")) {
      await Browser.close().catch(() => {});
      await sub.remove();
    }
  });
}
